import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { GiftTemplate } from '../../../types/modules/admin/giftTemplate.type'
import { CustomDate } from '../../../utils/day'
import UpdateGiftTemplateForm from './UpdateGiftTemplateForm'
import { formatNumber } from '../../../utils/formatNumber'
import DateTimeText from '../../ui/DateTimeText'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'
// import UpdateGiftCategoryForm from './UpdateGiftCategoryForm'

type Props ={
    template:GiftTemplate
}

function GiftTemplateItem({template}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
  return (
    <>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {formatNumber(template.id)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            <img src={template.imageUrl} alt="template" className='w-32 h-16 object-cover'/>
        </td>

         <td className="p-3 min-w-[200px] text-Black font-normal text-justify capitalize">
            <DateTimeText date={template.startDate??""}/>
        </td>

         <td className="p-3 min-w-[200px] text-Black font-normal text-justify capitalize">
            <DateTimeText date={template.endDate??""}/>
        </td>


        <PermissionGate permissions={[PermissionsKey.UpdateGiftCategory]}>
            <td className="p-3 min-w-[200px] text-Black font-normal">
                <button onClick={()=>setIsOpen(p=>!p)}>
                    <Edit/>
                </button>
            </td>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateGiftTemplateForm
        id={template.id}
        defaultValues={{startDate:template.startDate,endDate:template.endDate,imageurl:template.imageUrl}}
        onSubmitSuccess={()=>{
            setIsOpen(p=>false)
        }}
        />

        </CustomModal>
    </>
  )
}

export default GiftTemplateItem